<template>
  <div>
    <v-app-bar
        app
        elevate-on-scroll
    >

      <div id="title">
        <p class="ml-4">BOLKI</p>
      </div>
      <v-hover v-slot="{ hover }">
        <v-tabs class="ml-2">
          <v-tab
              v-for="item in items"
              :key="item.title"
              :to="item.to"
              :class="{ 'on-hover': hover }"
              link
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </v-hover>

      <v-spacer/>
      <v-btn color="#f5f5f5" variant="flat" style="text-transform: none" class="mr-4" @click="logout">
        Abmelden
      </v-btn>
    </v-app-bar>

    <div id="SpaceUnderMenu">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  data: () => (
      {
        items: [
          {title: 'Hochladen', icon: 'mdi-image', to: '/upload'},
          {title: 'Transekte', icon: 'mdi-image', to: '/transects'},
          {title: 'Fehlerhafte Bilder', icon: 'mdi-image', to: '/incorrectlyPictures'},
          {title: 'Einstellungen', icon: 'mdi-cog', to: '/settings'},
        ],
      }
  ),
  methods: {
    logout() {
      this.$store.dispatch('logout');
    }
  }
}
</script>


<style>

/* Space between menu and content */
div#SpaceUnderMenu {
  padding-top : 20px;
}

div#title {
  font-size     : 18px;
  padding-right : 50px;
  height        : 64px;
  line-height   : 64px;
  text-align    : center;
}

/* The hole menu background */
div.v-toolbar__content {
  color      : #ffffff !important;
  background : #011e4a;
}

/* Title: BOLKI*/
div.v-toolbar__title {
  font-size : 12px;
  width     : 100%;
  min-width : 1000px;
}

/*
#app > div > main > div > div:nth-child(1) > header > div > div.v-toolbar__title.v-app-bar-title > div.v-app-bar-title__content {
  top    : 0px;
  bottom : 0px;
}*/

/* Menu text color */
div.v-toolbar__content a {
  color          : #ffffff !important;
  /* menu not uppercase */
  text-transform : none !important;
}

/* Menu active */
a.v-tab--active.v-tab {
  background : #95094b !important;
  color      : #ffffff !important;
}

/* Menu bottom line */
div.v-tabs-slider-wrapper {
  color : #95094b !important;
}

/* Menu hover */
a.v-tab:hover {
  background : #95094b !important;
  color      : #ffffff !important;
}

</style>

